// @ts-nocheck
import * as $ from 'jquery';
import { AddRecipientToCartRequest } from './Models/AddRecipientToCartRequest';
import { InvalidNumbers } from './Models/InvalidNumbers';
import { Wizard } from './Wizard';
import { NotificationType } from 'Common/NotificationManager';
import Mediator from 'Common/Mediator';

export class EmployeeSection {
    public selectedProductTypeId: JQuery;
    private apiUrl: string;
    private csvImportUrl: string;
    private validateHjhPhoneNumberUrl: string;
    private validateForWhitelistProductTypeId: string;
    private employeeListTableBody: JQuery;
    private employeeListManualTableBody: JQuery;
    private pageSize: number;
    private recipientCountryCode: JQuery;
    private manualPhoneNumberText: JQuery;
    private manualCsvImportButton: JQuery;
    private exportInvalidNumbersButton: JQuery;
    private csvFileUpload: JQuery;
    private filterDepartment: JQuery;
    private searchEmployeesInput: JQuery;
    private searchEmployeesButton: JQuery;
    private addSelectedEmployeesButton: JQuery;
    private isSearching: boolean;
    private timeout: any;
    private addRecipientToCart: (request: AddRecipientToCartRequest) => any;
    private updateRecipientList: () => any;
    private loader: JQuery;
    private wizard: Wizard;
    private thresholdForShowingAllEmployees: number;
    private thresholdMessage: JQuery;
    private employeeTable: JQuery;
    private showAllButton: JQuery;
    private showAllHit: boolean;
    private notification: JQuery;
    private invalidNumbers: InvalidNumbers;

    constructor(private container: JQuery,
                apiUrl: string,
                csvImportUrl: string,
                validatePhoneNumberUrl: string,
                validateForWhitelistProductTypeId: string,
                addRecipientToCartCallback: (request: AddRecipientToCartRequest) => any,
                updateRecipientCallback: () => any) {
        this.apiUrl = apiUrl;
        this.pageSize = 100;
        this.csvImportUrl = csvImportUrl;
        this.validateHjhPhoneNumberUrl = validatePhoneNumberUrl;
        this.validateForWhitelistProductTypeId = validateForWhitelistProductTypeId;
        this.employeeListTableBody = container.find('#employee-list-tbody');
        this.employeeListManualTableBody = container.find('#employee-list-manual-tbody');
        this.loader = container.find('.section-loader');
        this.loader.hide();
        this.recipientCountryCode = container.find('#SelectedCountryCode');
        this.manualPhoneNumberText = container.find('#ManualPhoneNumber');
        this.manualCsvImportButton = container.find('.import-from-csv-button');
        this.exportInvalidNumbersButton = container.find('.export-invalid-numbers-button');
        this.csvFileUpload = container.find('#ManualCsvFileInput');
        this.filterDepartment = container.find('#FilterDepartment');
        this.searchEmployeesInput = container.find('#Search');
        this.searchEmployeesButton = container.find('#SearchButton');
        this.addSelectedEmployeesButton = container.find('.add-selected-employees-button');
        this.addRecipientToCart = addRecipientToCartCallback;
        this.updateRecipientList = updateRecipientCallback;
        this.selectedProductTypeId = container.find('#SelectedProductTypeId');
        this.wizard = new Wizard(container);
        this.thresholdForShowingAllEmployees = 200;
        this.thresholdMessage = container.find('.threshold-value');
        this.employeeTable = container.find('.pick-employee-area .employee-list');
        this.showAllButton = container.find('.show-all-employees');
        this.showAllHit = false;
        this.notification = $('body').find('[data-notification-manager]');
        this.invalidNumbers = new InvalidNumbers();
        this.initialize();
    }

    private static validateRecipientFields(countryCode: string, phoneNumber: string) {
        if (countryCode && phoneNumber) {
            if (countryCode !== '' && phoneNumber !== '') {
                if (/^[0-9]{7,12}$/.test(phoneNumber)) {
                    return true;
                }
            }
        }
        return false;
    }

    triggerUpload(): void {
        this.csvFileUpload.trigger('click');
    }

    initialize(): void {
        this.searchEmployeesInput.on('keyup', (event) => this.searchChanged(event));
        this.searchEmployeesInput.on('search', (event) => this.searchChanged(event));
        this.searchEmployeesButton.on('click', (event) => this.searchChanged(event));
        this.filterDepartment.on('change', (event) => this.searchChanged(event));

        this.employeeListTableBody.add(this.employeeListManualTableBody)
            .on('click', '.remove-ticket-count', (event) => this.reduceTicketCount(event));
        this.employeeListTableBody.add(this.employeeListManualTableBody)
            .on('click', '.add-ticket-count', (event) => this.addTicketCount(event));

        this.employeeListTableBody.add(this.employeeListManualTableBody)
            .on('click', '.group-tickets', (event) => this.clickGroupTicket(event));

        this.addSelectedEmployeesButton.on('click', (event) => this.addSelectedEmployees(event));
        this.manualCsvImportButton.on('click', (evt) => this.triggerUpload(evt));
        this.csvFileUpload.on('change', (event) => this.csvImport(event));

        this.exportInvalidNumbersButton.on('click', (event) => this.exportInvalidNumbers(event));

        this.recipientCountryCode.on('change', (evt) => this.changeCountryCode(evt));
        this.showAllButton.on('click', () => this.showAll());

        this.ensureCountryCodeName();
        this.searchEmployees();
        this.insertManualTableRow();
    }

    checkToInsertRowEvent(evt: JQueryEventObject) {
        this.checkToInsertRow($(evt.currentTarget).parent().parent());
    }

    checkToInsertRow(tr: JQuery, cancelInsert: boolean = false) {
        const phoneInput = tr.find('.phone-number input');
        const amountTicketButton = tr.find('.amount-tickets button');
        this.addManualPhoneNumber(tr, phoneInput, amountTicketButton, cancelInsert);
    }

    removeManualTableRow(evt: JQueryEventObject) {
        $(evt.currentTarget).parent().parent().remove();
        this.checkEnableSaveButton();
    }

    csvImport(): void {
        const files = (this.csvFileUpload[0] as HTMLInputElement).files;

        // Check file selected or not
        if (files.length > 0) {
            let postedData = new FormData();
            postedData.append('file', files[0]);
            let section = this;
            let importUrl = this.csvImportUrl + `?selectedProductTypeId=${this.selectedProductTypeId.val()}`;

            $.ajax({
                url: importUrl,
                type: 'post',
                data: postedData,
                contentType: false,
                processData: false,
                success: function (data) {
                    let i;
                    section.employeeListManualTableBody.find('tr.added-manual-row.empty').remove();
                    for (i = 0; i < data.length; i = i + 1) {
                        let employee = {
                            FirstName: '',
                            LastName: '',
                            DepartmentName: '',
                            CountryCode: data[i].CountryCode,
                            PhoneNumber: data[i].PhoneNumber,
                            IsValid: data[i].IsValid,
                            IsValidHjhPhoneNumber: data[i].IsValidHjhPhoneNumber,
                            ErrorMessage: data[i].ErrorMessage
                        };

                        let row = section.createManualEmployeeRow(employee);
                        section.checkToInsertRow(row, true);
                        section.employeeListManualTableBody.append(row);

                        $('#' + row.attr('id') + ' input').on('change', (evt) => section.checkToInsertRowEvent(evt));
                        $('#' + row.attr('id') + ' .remove-button')
                            .on('click', (evt) => section.removeManualTableRow(evt));
                    }
                    section.insertManualTableRow();
                    section.checkEnableSaveButton();
                    section.csvFileUpload.val('');
                    section.notification.hide();
                },
                error: function (data) {
                    const json = data.responseJSON;
                    let message = json.Message;
                    if (!message) {
                        message = 'An error occured';
                    }
                    Mediator.instance.publish('notification:show', message, NotificationType.Error, true);
                    section.notification.show();
                }
            });
        }
    }

    exportInvalidNumbers(): void {
        let section = this;
        let exportUrl = '/exportspage/exportinvalidsendticketnumberscsv';

        const result = $('.input-validation-error')

        result.each(function () {
            let input = $(this);

            const countryCode = input.parent('.phone-number').siblings('.selected-country').children('select#SelectedCountryCode').children('option:selected').val()

            section.invalidNumbers.recipients.push({
                name: '',
                department: '',
                countryCode: countryCode,
                phoneNumber: input.val(),
                count: 0,
                groupTicket: false
            });
        });

            $.ajax({
                url: exportUrl,
                type: 'post',
                data: this.invalidNumbers,
                xhrFields: {
                    responseType: 'blob'
                },
                success: function (data) {
                    console.log('success');
                    section.invalidNumbers.recipients = [];
                    let a = document.createElement('a');
                    let url = window.URL.createObjectURL(data);
                    a.href = url;
                    a.download = 'invalid-numbers.csv';
                    document.body.append(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                },
                error: function () {
                    Mediator.instance.publish('notification:show', 'An error occured', NotificationType.Error, true);
                    section.notification.show();
                }
            });
    }

    reduceTicketCount(evt: JQueryEventObject): void {
        let target = $(evt.currentTarget);
        let type = 'remove';

        if (target.is('[data-adjust-all]')) {
            this.changeTicketCountForAll(target, type);
        } else {
            this.changeTicketCount($(evt.currentTarget), type);
        }
        this.checkEnableSaveButton();
    }

    addTicketCount(evt: JQueryEventObject): void {
        let target = $(evt.currentTarget);
        let type = 'add';

        if (target.is('[data-adjust-all]')) {
            this.changeTicketCountForAll(target, type);
        } else {
            this.changeTicketCount($(evt.currentTarget), 'add');
        }

        this.checkEnableSaveButton();
    }

    changeTicketCountForAll(button: JQuery, type: string) {
        let trs = button.closest('tbody').find('tr');

        let section = this;
        trs.each(function () {
            section.changeTicketCountForRow($(this), type);
        });
    }

    changeTicketCount(button: JQuery, type: string) {
        let tr = button.closest('tr');
        this.changeTicketCountForRow(tr, type);
    }

    changeTicketCountForRow(tr: JQuery, type: string) {
        let count, button;
        let ticketCount = tr.data('employee-ticket-count');
        if (type === 'remove') {
            button = tr.find('.remove-ticket-count');
            count = button.next();
            if (ticketCount > 0) {
                ticketCount -= 1;
            }

            if (ticketCount === 0) {
                button.siblings('button').removeClass('green');
            }
        } else {
            button = tr.find('.add-ticket-count');
            count = button.prev();
            ticketCount += 1;
            if (ticketCount > 0) {
                button.addClass('green');
            }
        }
        tr.data('employee-ticket-count', ticketCount);
        count.html(ticketCount);

        if (ticketCount > 1) {
            tr.addClass('multiple-tickets-active');
        } else {
            tr.removeClass('multiple-tickets-active');
        }
    }

    clickGroupTicket(evt: JQueryEventObject): void {
        let target = $(evt.currentTarget);
        let input = target[0] as HTMLInputElement;
        target.closest('tr').data('employee-group-ticket', input.checked);
    }

    showAll() {
        this.employeeListTableBody.addClass('showAll');
        this.showAllButton.hide();
        this.showAllHit = true;
    }

    searchChanged(): void {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        this.searchEmployees();
    }

    searchEmployees(): void {
        if (!this.isSearching) {
            const section = this;

            let query = section.searchEmployeesInput.val();
            let department = section.filterDepartment.val();
            const pageSize = section.pageSize;

            this.timeout = setTimeout(function () {
                let searchUrl = section.apiUrl +
                    `?ps=${pageSize}&sa=True&q=${query}&d=${department}`;

                section.isSearching = true;
                section.loader.show();
                section.employeeTable.hide();
                section.thresholdMessage.hide();
                section.employeeListTableBody.removeClass('showAll');
                section.showAllButton.hide();

                $.ajax({
                    url: searchUrl,
                    dataType: 'json',
                    success: function (data) {
                        section.employeeListTableBody.empty();
                        let i;

                        if (query === '' &&
                            department === '' &&
                            data.items.length <= section.thresholdForShowingAllEmployees) {
                            if (!section.showAllHit) {
                                section.employeeListTableBody.addClass('noQuery');
                                section.showAllButton.show();
                            } else {
                                section.employeeListTableBody.addClass('showAll');
                            }

                            section.employeeTable.show();
                            let allRow = section.createSelectAllRow();
                            section.employeeListTableBody.append(allRow);
                            for (i = 0; i < data.items.length; i = i + 1) {
                                let employee = data.items[i];
                                let row = section.createEmployeeRow(employee);
                                section.employeeListTableBody.append(row);
                            }
                        } else if (query === '' &&
                            department === '' &&
                            data.items.length > section.thresholdForShowingAllEmployees) {
                            section.thresholdMessage.show();
                            section.employeeTable.hide();
                        } else {
                            section.employeeTable.removeClass('noQuery');
                            section.thresholdMessage.hide();
                            section.employeeTable.show();
                            let allRow = section.createSelectAllRow();
                            section.employeeListTableBody.append(allRow);
                            for (i = 0; i < data.items.length; i = i + 1) {
                                let employee = data.items[i];
                                let row = section.createEmployeeRow(employee);
                                section.employeeListTableBody.append(row);
                            }
                        }
                        section.isSearching = false;
                        section.loader.hide();
                    },
                    error: function () {
                        section.loader.hide();
                    }
                });
            });
        }
    }

    insertManualTableRow() {
        const id = 'Manual-Row-' + $('#employee-list-manual-tbody tr').length;
        const newRow = $('.table-row-template').clone();
        newRow.attr('id', id);
        newRow.addClass('added-manual-row empty').removeClass('table-row-template');

        $('#employee-list-manual-tbody').append(newRow);
        $('#' + id + ' input').on('change', (evt) => this.checkToInsertRowEvent(evt));
        $('#' + id + ' .remove-button').on('click', (evt) => this.removeManualTableRow(evt));
    }

    createCsvRow(employee: any): JQuery {
        const id = 'Manual-Row-0' + $('#employee-list-manual-tbody tr').length;
        const newRow = $('.table-row-template').clone();
        newRow.attr('id', id);
        newRow.addClass('added-manual-row').removeClass('table-row-template');

        newRow.data('employee-ticket-count', 1);
        newRow.data('employee-phonenumber', employee.PhoneNumber);
        newRow.data('employee-country-code', employee.CountryCode);
        newRow.find('.phone-number input').val(employee.PhoneNumber);
        newRow.find('.selected-country select').val(employee.CountryCode);
        newRow.find('.amount-tickets .count').text(1);
        return newRow;
    }

    createSelectAllRow(): JQuery {
        let row = $('<tr data-adjust-all data-employee-ticket-count="0" />');
        row.append($('<td/>').text('Alle'));
        row.append($('<td/>'));
        row.append($('<td/>'));
        row.append($('<td/>').html(
            '<button data-adjust-all class="round-button remove-ticket-count">-</button><span class="count">0</span><button data-adjust-all class="round-button add-ticket-count">+</button>'));
        row.append($('<td class="multiple-tickets"/>').html(
            '<input type="checkbox" class="group-tickets form-check-input" />'));
        return row;
    }

    createManualEmployeeRow(employee: any): JQuery {
        return this.createCsvRow(employee);
    }

    createEmployeeRow(employee: any): JQuery {
        let row = $(`<tr class='input-validation-success' data-employee-name='${employee.firstName + ' ' +
        employee.LastName}' data-employee-department='${employee.departmentName}' 
            data-employee-phonenumber='${employee.phoneNumber}' data-employee-ticket-count='0' />`);
        row.append($('<td class="name"/>').text(employee.firstName + ' ' + employee.lastName));
        row.append($('<td class="department"/>').text(employee.departmentName));
        row.append($('<td  class="phone"/>').text(employee.phoneNumber));
        row.append($('<td  class="ticket-count"/>').html(
            '<button class="round-button remove-ticket-count">-</button><span class="count">0</span><button class="round-button add-ticket-count">+</button>'));
        row.append($('<td class="multiple-tickets"/>').html(
            '<input type="checkbox" class="group-tickets form-check-input" />'));
        return row;
    }

    checkEnableSaveButton(): void {
        const result = this.getEmployeesToAdd();
        let validNumbers = false;
        result.each(function () {
            let input = $(this).find('.phone-number input');

            if (!input.hasClass('input-validation-error')) {
                validNumbers = true;
            }
        });

        if (result.length > 0 && validNumbers) {
            this.addSelectedEmployeesButton.prop('disabled', false);
        } else {
            this.addSelectedEmployeesButton.prop('disabled', true);
        }

        const allRows = this.getAllEmployeeRows();
        let hasInvalidNumbers = false;
        allRows.each(function () {
            let input = $(this).find('.phone-number input');

            if (input.hasClass('input-validation-error')) {
                hasInvalidNumbers = true;
            }
        });

        if (allRows.length > 0 && hasInvalidNumbers) {
            this.exportInvalidNumbersButton.show();
        } else {
            this.exportInvalidNumbersButton.hide();
        }
    }

    getEmployeesToAdd(): JQuery {
        let trs = this.getAllEmployeeRows().find('tr.input-validation-success').not('[data-adjust-all]');
        return trs.filter(function () {
            return parseInt($(this).data('employee-ticket-count')) > 0;
        });
    }

    getAllEmployeeRows(): JQuery {
        return this.employeeListTableBody.add(this.employeeListManualTableBody);
    }

    getAdjustAllRows(): JQuery {
        return this.employeeListTableBody.add(this.employeeListManualTableBody).find('[data-adjust-all]');
    }

    private static generateGuid(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    addSelectedEmployees(): void {
        const result = this.getEmployeesToAdd();
        let section = this;
        result.each(function () {
            let phoneNumber = $(this).data('employee-phonenumber');
            let ticketCount = parseInt($(this).data('employee-ticket-count'));
            let name = $(this).data('employee-name');
            let department = $(this).data('employee-department');
            let groupTicket = $(this).data('employee-group-ticket');
            let countryCode = $(this).data('employee-country-code');
            let id = EmployeeSection.generateGuid();

            section.addRecipientToCart(
                new AddRecipientToCartRequest(name, department, phoneNumber, countryCode, ticketCount, groupTicket, id));

            // Reset row and counter
            section.resetRow($(this));
        });

        let allRows = this.getAdjustAllRows();
        allRows.each(function () {
            section.resetRow($(this));
        });

        this.updateRecipientList();
        this.checkEnableSaveButton();
        this.employeeListManualTableBody.find('tr.added-manual-row').remove();
        this.wizard.showNumberSelection();
        this.resetSection();
    }

    resetRow(row: JQuery): void {
        row.data('employee-ticket-count', 0);
        row.find('.count').html('0');
        row.find('button').removeClass('green');
    }

    private resetSection() {
        this.filterDepartment.val('');
        this.searchEmployeesInput.val('');
        this.employeeListTableBody.html();
    }

    reset() {
        this.filterDepartment.val('');
        this.searchEmployeesInput.val('');
        this.showAllHit = false;
        this.employeeListManualTableBody.find('tr.added-manual-row').remove();
        this.exportInvalidNumbersButton.hide();
        this.addSelectedEmployeesButton.prop('disabled', true);
        this.searchEmployees();
        this.insertManualTableRow();
    }

    private addManualPhoneNumber(tr: JQuery, phoneInput: JQuery, amountTicketButton: JQuery, cancelInsert: boolean) {
        const countryCode = tr.find('.selected-country select option:selected').val();
        const phoneNumber = phoneInput.val();
        if (EmployeeSection.validateRecipientFields(countryCode, phoneNumber)) {
            const selectedProductTypeInput = this.selectedProductTypeId;
            if (selectedProductTypeInput.val() === this.validateForWhitelistProductTypeId) {
                this.validateHjhPhoneNumber(countryCode, phoneNumber).done(data => {
                    if (data) {
                        this.manualAddSuccess(tr, phoneInput, amountTicketButton, cancelInsert);
                    } else {
                        $('#InvalidHjhPhoneNumber').modal('show');
                        phoneInput.addClass('input-validation-error');
                        amountTicketButton.prop('disabled', true);
                        tr.removeClass('input-validation-success');
                        tr.data('employee-phonenumber', '');
                    }
                    this.checkEnableSaveButton();
                }).fail(() => {
                    $('#InvalidHjhPhoneNumber').modal('show');
                    phoneInput.addClass('input-validation-error');
                    amountTicketButton.prop('disabled', true);
                    tr.removeClass('input-validation-success');
                    tr.data('employee-phonenumber', '');
                    this.checkEnableSaveButton();
                });
            } else {
                if (tr.attr('id') === tr.parent().children().last().attr('id')) {
                    this.manualAddSuccess(tr, phoneInput, amountTicketButton, cancelInsert);
                } else {
                    phoneInput.removeClass('input-validation-error');
                    amountTicketButton.prop('disabled', false);
                    tr.addClass('input-validation-success');
                    tr.data('employee-phonenumber', phoneNumber);
                    tr.data('employee-country-code', countryCode);
                }
            }
        } else {
            $('#IncorrectPhone').modal('show');
            phoneInput.addClass('input-validation-error');
            amountTicketButton.prop('disabled', true);
            tr.removeClass('input-validation-success');
            tr.data('employee-phonenumber', '');
        }
        this.checkEnableSaveButton();
    }

    private manualAddSuccess(tr: JQuery, phoneInput: JQuery, amountTicketButton: JQuery, cancelInsert: boolean) {
        const countryCode = tr.find('.selected-country select option:selected').val();
        const phoneNumber = phoneInput.val();
        phoneInput.removeClass('input-validation-error');
        amountTicketButton.prop('disabled', false);
        tr.addClass('input-validation-success');
        tr.removeClass('empty');
        tr.data('employee-phonenumber', phoneNumber);
        tr.data('employee-country-code', countryCode);
        tr.data('employee-ticket-count', 1);
        if (!cancelInsert && tr.attr('id') === tr.parent().children().last().attr('id')) {
            this.insertManualTableRow();
        }
    }

    private validateHjhPhoneNumber(countryCode: string, phoneNumber: string) {
        let validateUrl = this.validateHjhPhoneNumberUrl + `?ph=${phoneNumber}&cc=${countryCode}`;

        return $.ajax({
            url: validateUrl,
            type: 'get',
            contentType: false,
            processData: false
        });
    }

    private changeCountryCode() {
        this.ensureCountryCodeName();
    }

    private ensureCountryCodeName() {
        this.recipientCountryCode.find('option').each(function (index, elem) {
            var el = $(elem);
            el.text(el.attr('data-name'));
        });

        var selected = this.recipientCountryCode.find('option:selected');
        selected.text(selected.val());
    }
}
